import {useDebugValue} from 'react';

import {
    useDetailsModalActions,
    useDetailsModalEvents,
    useDetailsModalOptions,
    useDetailsModalSettings,
    useDetailsModalTranslations
} from './';

function useDetailsModal(props) {
    const {
        events
    } = useDetailsModalEvents(props);

    const {
        options
    } = useDetailsModalOptions(props);

    const {
        initialSettings,
        settings,
        changeSettings
    } = useDetailsModalSettings(props);

    const {
        translations
    } = useDetailsModalTranslations(props);

    const actions = useDetailsModalActions({
        events,
        options,
        initialSettings,
        settings,
        changeSettings,
        translations
    });

    const result = {
        actions,
        events,
        options,
        settings,
        translations
    };

    useDebugValue(result);

    return result;
}

export {useDetailsModal};
